export { default } from "./AutoGeneratedWritePrompts";
